// @ts-nocheck

import Helmet from 'react-helmet'
import React, { FC, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IconSpotify } from 'Stories/Icon/Icon.stories'
import { BlockOfText } from 'Stories/BlockOfText/BlockOfText.stories'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { getIsAuth } from 'Redux/selectors/auth'
import { getCampaignsLoader } from 'Redux/selectors/campaigns'
import { CampaignPlatformTypeEnum } from 'Types/index'
import {
  BtnReviewBlock,
  CreateCampaignBlock,
  CreateCampaignBody,
  CreateCampaignContainer,
  CreateCampaignHead,
  Text,
  PlatformContainer,
  PlatformsWrapper,
  TextBlock,
  TitleBlock,
} from './styles'
import AddSpotifyTrackSearch from '../../../CreateCampaignPage/components/AddSpotifyTrackSearch'
import ServerOverloadedModal from '../../../ui/ServerDoesNotRespondPopup'
import UserRegisterModal from '../UserRegisterModal'
import { CreateCampaignLayoutPropsType } from './CreateCampaignLayoutTypes'

export const CreateCampaignLayout: FC<CreateCampaignLayoutPropsType> = ({
  accessToken,
  isCheckedSpotify,
  spotifyTrack,
  spotifyTracks,
  setIsChangedTrack,
  isCheckedTikTok,
  isChangedTrack,
  handleSubmit,
  serverOverloadedModal,
  setServerOverloadedModal,
  modalFormRegister,
  setModalFormRegister,
  children,
}) => {
  const { t } = useTranslation()
  const loading: boolean = useSelector(getCampaignsLoader)

  const [isShowButtonSendCampaign, setIsShowButtonSendCampaign] = useState(
    false
  )
  const [errorText, setErrorText] = useState('')
  const isAuth = useSelector(getIsAuth)

  const timer = useRef(null)

  const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [pathname])

    return null
  }

  useEffect(() => {
    if (spotifyTrack) {
      timer.current = setTimeout(() => setIsShowButtonSendCampaign(true), 2000)
    } else {
      setIsShowButtonSendCampaign(false)
    }
  }, [spotifyTrack])

  useEffect(() => {
    !isCheckedSpotify && clearInterval(timer.current)
  }, [isCheckedSpotify])

  return (
    <CreateCampaignContainer>
      {children}
      <CreateCampaignBlock isAuth={isAuth}>
        {children && <Helmet title="SoundCampaign - Create a new campaign" />}
        <CreateCampaignHead>
          {t('campaignsPage.createNewCampaign')}
        </CreateCampaignHead>
        <ScrollToTop />
        <CreateCampaignBody>
          <PlatformsWrapper>
            <PlatformContainer>
              <TitleBlock>
                <IconSpotify />
                <div>{t('createCampaignPage.spotifyCampaign')}</div>
              </TitleBlock>

              {!isShowButtonSendCampaign && !errorText && (
                <Text>
                  {t(
                    'createCampaignPage.getTheBestPlaylistMatchForYourTrackOutOfMoreThan20000'
                  )}
                </Text>
              )}
              <ServerOverloadedModal
                modalIsOpen={serverOverloadedModal}
                toggle={() =>
                  setServerOverloadedModal?.(!serverOverloadedModal)
                }
              />
              {isCheckedSpotify ? (
                <AddSpotifyTrackSearch
                  accessToken={accessToken}
                  isAuth={isAuth}
                  track={spotifyTrack}
                  tracks={spotifyTracks}
                  isChangedTrack={isChangedTrack}
                  setIsChangedTrack={setIsChangedTrack}
                  campaignType={CampaignPlatformTypeEnum.SPOTIFY}
                  errorText={errorText}
                  setErrorText={setErrorText}
                />
              ) : (
                <TextBlock>
                  <BlockOfText
                    content={t('createCampaignPage.getTheBestPlaylistMatch')}
                  />
                </TextBlock>
              )}
            </PlatformContainer>
          </PlatformsWrapper>
          {isShowButtonSendCampaign && (
            <BtnReviewBlock>
              <GreenBtn color="green" disabled={loading} onClick={handleSubmit}>
                {t('createCampaignPage.sendCampaignToReview')}
              </GreenBtn>
            </BtnReviewBlock>
          )}
        </CreateCampaignBody>
        <UserRegisterModal
          isCheckedTikTok={isCheckedTikTok}
          campaignType={CampaignPlatformTypeEnum.SPOTIFY}
          modal={modalFormRegister}
          toggle={() => setModalFormRegister?.(!modalFormRegister)}
        />
      </CreateCampaignBlock>
    </CreateCampaignContainer>
  )
}
